module.exports = __webpack_public_path__ + "static/media/bongo_favicon-192.5e7d1987.ico";